var map = {
	"./Buters.mp3": 136,
	"./Cafe del Mar (bel).mp3": 137,
	"./Field.mp3": 138,
	"./Fling (janett).mp3": 139,
	"./Klon.mp3": 140,
	"./Kolibelnaya.mp3": 141,
	"./MaxZim.mp3": 142,
	"./Navprostets.mp3": 143,
	"./Neon.mp3": 144,
	"./Podzakat.mp3": 145,
	"./Shkatulka.mp3": 146,
	"./Shkatulka_2.mp3": 147,
	"./Snow Mood (yenia).mp3": 148,
	"./Sny.mp3": 149,
	"./Sopilka1.mp3": 150,
	"./Sopilka2.mp3": 151,
	"./Sopilka3.mp3": 152,
	"./Sunset.mp3": 153,
	"./beatiful_forest_and_water.mp3": 154,
	"./clear_birds.mp3": 155,
	"./crow.mp3": 156,
	"./forest_song.mp3": 157,
	"./happy_birds.mp3": 158,
	"./laugh_janett.mp3": 159,
	"./laugh_yenia2.mp3": 160,
	"./morning_birds.mp3": 161,
	"./night_sounds.mp3": 162,
	"./running-water.mp3": 163,
	"./waterfall.mp3": 164,
	"./woodpecker.mp3": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;